import { render } from "./EventLayout.vue?vue&type=template&id=218a7f38"
import script from "./EventLayout.vue?vue&type=script&lang=js"
export * from "./EventLayout.vue?vue&type=script&lang=js"

import "./EventLayout.vue?vue&type=style&index=0&id=218a7f38&scope=true&lang=css"

import exportComponent from "/Users/morris.lin/Self/project/vue-rick-and-morty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__